import React from 'react';
import gh_icon from "../img/ic_github.png"
import gm_icon from "../img/ic_gmail.png";
import in_icon from "../img/ic_instagram.png";
import li_icon from "../img/ic_linkedin.png"

const Contact = () => {
	return (<div id="contact" className="contact-container">
		<div>
			<a href="https://github.com/Shibinlal"><span><img alt="github icon" src={gh_icon} /></span></a>
			<a href="https://mail.google.com/mail/u/0/?view=cm&fs=1&to=shibinlalpurushothaman@gmail.com&tf=1"><span><img alt="gmail icon" src={gm_icon} /></span></a>
			<a href="https://www.instagram.com/shibinlal_purushothaman/"><span><img alt="instagram icon" src={in_icon} /></span></a>
			<a href="https://www.linkedin.com/in/shibin-lal-31a40392/"><span><img alt="linked icon" src={li_icon} /></span></a>
		</div>
	</div>)
}

export default Contact;